import { CSSProperties } from 'react'

const styles: {
  overlay: CSSProperties
  windowRow: CSSProperties
  window: CSSProperties
  windowHeader: CSSProperties
  windowHeaderLabel: CSSProperties
  windowTitle: CSSProperties
  closeIcon: CSSProperties
  log: CSSProperties
  logLine: CSSProperties
  logLineError: CSSProperties
  emptyText: CSSProperties
  taskbar: CSSProperties
  taskbarItem: CSSProperties
  taskbarLabel: CSSProperties
  taskbarLabelActive: CSSProperties
  taskbarClose: CSSProperties
} = {
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    pointerEvents: 'none',
    zIndex: 99999,
  },
  windowRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    padding: '0 8px 8px',
    alignItems: 'flex-end',
  },
  window: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 320px',
    maxWidth: 520,
    height: 320,
    backgroundColor: '#3a3a3a',
    borderRadius: 12,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
    overflow: 'hidden',
    pointerEvents: 'auto',
  },
  windowHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 12px',
    borderBottom: '1px solid #4d4d4d',
  },
  windowHeaderLabel: {
    flex: 1,
  },
  windowTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
  closeIcon: {
    fontSize: 16,
    color: '#aaaaaa',
  },
  log: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflowY: 'auto',
    padding: '8px 12px',
    backgroundColor: '#1b1b1b',
  },
  logLine: {
    fontFamily: 'monospace',
    fontSize: 12,
    color: '#d0d0d0',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
  logLineError: {
    fontFamily: 'monospace',
    fontSize: 12,
    color: '#ff6b6b',
    fontWeight: 600,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
  emptyText: {
    color: '#aaaaaa',
    padding: '16px 8px',
    textAlign: 'center',
  },
  taskbar: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
    padding: 8,
    backgroundColor: '#2a2a2a',
    borderTop: '1px solid #4d4d4d',
    pointerEvents: 'auto',
  },
  taskbarItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    padding: '6px 10px',
    backgroundColor: '#3a3a3a',
    borderRadius: 6,
  },
  taskbarLabel: {
    fontSize: 13,
    color: '#cccccc',
  },
  taskbarLabelActive: {
    fontSize: 13,
    color: '#4caf50',
    fontWeight: 600,
  },
  taskbarClose: {
    fontSize: 13,
    color: '#aaaaaa',
  },
}

export default styles
